import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-3" }

import { onMounted, ComputedRef, computed, ref } from 'vue'

  // Components
  import DocumentSkeleton from './DocumentSkeleton.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentSectionSkeleton',
  setup(__props) {

  // Vue
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "section-title title-4 text-primary-black skeleton-title shimmer" }, null, -1)),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
      return _createElementVNode("div", {
        key: `${i}-loader`
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "seperator" }, null, -1)),
        _createVNode(DocumentSkeleton)
      ])
    }), 64))
  ]))
}
}

})